import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import AppButton from '../partials/Navigation/AppButton'

import AppDispatcher from '../../dispatchers/AppDispatcher'
// Import the HOC
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/home.module.css'

const Applications = function Applications ({ applications, customerID }) {
  if (!Array.isArray(applications)) {
    return null
  }

  const buttons = []

  const sortKey = (group) => `${group.name}-${group.icon}-${group.device_group}`

  applications
    .sort((a, b) => sortKey(a).localeCompare(sortKey(b)))
    .forEach((group) => {
      buttons.push(
        <AppButton
          icon={group.icon}
          link={encodeURI(
            `/${customerID}/devices?groupID=${group.groupID}&deviceGroupName=${group.name}`
          )}
          label={group.name || '-'}
          key={group.groupID}
        />
      )
    })

  return <div className={styles.list}>{buttons}</div>
}

Applications.propTypes = {
  applications: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  customerID: PropTypes.string,
}

// Convert to functional component
function HomeComponent (props) {
  // Use hooks for state and navigation
  const [customerID, setCustomerID] = useState()
  const navigate = useNavigate()

  // Effect for initial setup - equivalent to componentDidMount
  useEffect(() => {
    AppDispatcher.dispatch({
      action: 'unload-metric',
    })

    // Use React Router's navigate instead of window.location.href
    // but only if we're not already on /home to avoid navigation loops
    if (window.location.pathname !== '/home') {
      navigate('/home')
    }
  }, [navigate])

  // Handle getting customer data - based on your original getCustomer method
  useEffect(() => {
    const {
      data: {
        user: {
          ready: userReady = false,
          data: { customer_id = false } = {},
        } = {},
        customer: { ready: customerReady = false } = {},
        customer_id: customerIDAlt = false,
      } = {},
    } = props

    if (
      userReady &&
      customerReady &&
      (customerIDAlt || customer_id) &&
      customerID !== (customerIDAlt || customer_id)
    ) {
      const newCustomerID = customerIDAlt || customer_id
      setCustomerID(newCustomerID)
      AppDispatcher.dispatch({
        action: 'get-customer',
        customerID: newCustomerID,
      })
    }
  }, [props, customerID])

  // Get data from props with safe defaults
  const {
    data: {
      customer: {
        data: {
          applications = [],
          id: customerId = '',
          customer_name: customerName = '',
        } = {},
      } = {},
    } = {},
    pages = {},
    auth: { logout } = {},
  } = props

  // Extract page path information
  let page = ''
  if (props.route && props.route.path) {
    page = props.route.path
  }

  return (
    <div>
      <Helmet><title>{pages.Home || 'Altrac App'}</title></Helmet>
      <NavigationBar page={page} logOut={logout} name={customerName} />
      <Applications applications={applications} customerID={customerId} />
      <Footer />
    </div>
  )
}

HomeComponent.propTypes = {
  pages: PropTypes.object,
  route: PropTypes.object,
  data: PropTypes.object,
  auth: PropTypes.object,
}

// Wrap the component with our HOC to get AppStore data
const Home = withAppStore(HomeComponent)
export default Home
